import { ResponsePayload } from "@/types/model";
import { getData } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const getBackgroundColours = async (
  token: string,
  baseUrl: string,
  params?: object,
  config?: any
) => {
  const queryPath = `${baseUrl}/tool_customizations/background_colours`;
  return await getData(token, queryPath, params, config).then(
    (response: ResponsePayload) => deserialize(response.data)
  );
};
